import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { I18n } from 'react-redux-i18n'
import Grid from 'material-ui/Grid'
import { FormControlLabel } from 'material-ui/Form'
import Checkbox from 'material-ui/Checkbox'
import Radio, { RadioGroup } from 'material-ui/Radio'
import TextField from 'material-ui/TextField'
import MenuItem from 'material-ui/Menu/MenuItem'
import Button from 'material-ui/Button'
import classNames from 'classnames'
import _ from 'lodash'
import { createSelector } from 'reselect'

import Loading from 'components/loading'
import ContractModal from './contract_modal'
import calculator from 'modules/calculator'
import { getPricesDebounced as getCurrencies } from 'modules/calculations/prices'
import { getTokens } from 'modules/users/current/tokens'
import { addPromocode } from 'modules/users/current/promocodes'
import { getActivePromocode } from 'modules/users/current/promocodes/active'
import { toggleGenerateContract, checkPurchaseAgreement } from 'modules/contracts'
import { getTokenPurchaseTypes } from 'modules/contracts/token_purchase_types'
import { getDeposits } from 'modules/users/current/deposits'
import { currency_icon } from 'core/utils'
import jsonSelector from 'selectors/json'
import calculatorSelector from 'selectors/calculator'
import parametersSelector from 'selectors/parameters'
import pricesSelector from 'selectors/prices'

const {
  calculateCoinAmount,
  calculateIncrementCoinAmount,
  calculateDecrementCoinAmount,
  calculateToggleAllDeposits,
  calculateTokenPurchaseType,
  setCode
} = calculator('buy_tokens_form', { getCurrencies })

const BuyTokensForm = ({
  calculateCoinAmount,
  calculateIncrementCoinAmount,
  calculateDecrementCoinAmount,
  calculateToggleAllDeposits,
  calculateTokenPurchaseType,
  setCode,
  addPromocode,
  getActivePromocode,
  toggleGenerateContract,
  checkPurchaseAgreement,
  user_balances,
  calculator,
  config_parameters,
  available_currencies,
  current_promocode,
  token_purchase_types,
  purchase_agreements,
  buy_button_disabled
}) => (
  <form className="buy-tokens-form">
    <h2>{I18n.t('nav.buy_coins', { coin_name: config_parameters['coin.name'] })}</h2>
    {_.isEmpty(user_balances) && (
      <p className="text-center">
        <Link to="/deposits">{I18n.t('tokens.deposit_first')}</Link>
      </p>
    )}
    <br />
    <br />
    <Grid container id="tokens-form-wrap" direction="column" spacing={40}>
      <Grid item>
        <Grid container className="gray-box">
          <Grid item xs={12} className="form-token-label">
            <label>{I18n.t('tokens.pay_with')}</label>
          </Grid>
          <Grid item md={5} xs={12}>
            <div className="list-currency">
              {!_.isEmpty(user_balances) ? (
                <TextField
                  id="calculator-currency-btn"
                  select
                  className="form-control-mui current-currency list-currency-icon"
                  value={calculator.code}
                  disabled={calculator.all_deposits}
                  onChange={e => setCode(e.target.value)}
                  fullWidth
                  margin="dense"
                >
                  {_.map(user_balances, (currency, currency_code) => (
                    <MenuItem
                      key={currency_code}
                      value={currency_code}
                      className="list-currency-icon"
                    >
                      {currency_icon(currency_code, 'currency-select-bg')}
                      {available_currencies[currency_code].name}
                    </MenuItem>
                  ))}
                </TextField>
              ) : (
                <a className="btn btn-raised btn-select current-currency btn-block disabled-list">
                  {I18n.t('tokens.no_coins')}
                </a>
              )}
            </div>
          </Grid>
          <Grid item md={7} xs={12}>
            <div className="form-group">
              <div className={classNames({ disabled: _.isEmpty(user_balances) })}>
                <FormControlLabel
                  control={
                    <Checkbox
                      id="form-token-spend-all-checkbox"
                      className="check"
                      autoComplete="off"
                      checked={calculator.all_deposits}
                      disabled={_.isEmpty(user_balances)}
                      onChange={() => calculator.loading || calculateToggleAllDeposits()}
                    />
                  }
                  label={I18n.t('tokens.spend_all_funds')}
                />
              </div>
            </div>
          </Grid>
        </Grid>
      </Grid>

      <Grid item>
        <Grid container className="gray-box">
          <Grid item md={6} xs={12}>
            <div id="form-token-label-amount" className="form-token-label">
              <label>{I18n.t('tokens.amount')}</label>
            </div>
            <div id="form-token-input-amount">
              <div className="input-group input-amount counter">
                <a
                  className="minus"
                  disabled={_.isEmpty(user_balances) || calculator.all_deposits}
                  onClick={e => e.preventDefault() || calculateDecrementCoinAmount()}
                >
                  <i className="fa fa-minus" />
                </a>
                <TextField
                  className="input-number coin-amount"
                  disabled={_.isEmpty(user_balances) || calculator.all_deposits}
                  value={calculator.coin_amount}
                  onChange={e => calculateCoinAmount(e.target.value)}
                />
                <a
                  className="plus"
                  disabled={_.isEmpty(user_balances) || calculator.all_deposits}
                  onClick={e => e.preventDefault() || calculateIncrementCoinAmount()}
                >
                  <i className="fa fa-plus" />
                </a>
              </div>
            </div>
          </Grid>

          {calculator.coin_bonus > 0 && (
            <Grid item md={3} xs={12}>
              <div id="form-token-label-bonus" className="form-token-label">
                <label>{I18n.t('tokens.bonus')}</label>
              </div>
              <div id="bonus-amount-box">
                <p>
                  <span className="coins-bonus">{I18n.l(calculator.coin_bonus)}</span>
                </p>
              </div>
            </Grid>
          )}

          <Grid item md={3} xs={12}>
            <div id="form-token-label-total" className="form-token-label">
              <label>{I18n.t('tokens.total_price')}</label>
            </div>
            <div id="total-price-box">
              {calculator.all_deposits && (
                <div className="buy-form-user-deposits">
                  {_.map(calculator.deposits.balances, (value, code) => (
                    <div key={code}>
                      {code}: {I18n.l(value)}
                    </div>
                  ))}
                </div>
              )}
              {calculator.all_deposits &&
                !calculator.deposits.one_currency && <div className="price-box-separator" />}
              <p
                className={classNames({
                  'coin-box-big': calculator.all_deposits && !calculator.deposits.one_currency
                })}
              >
                <span className="coin-price">{I18n.l(parseFloat(calculator.coin_price))}</span>{' '}
                <span className="coin-price-currency">
                  {calculator.all_deposits ? calculator.deposits.currency : calculator.code}
                </span>
              </p>
            </div>
          </Grid>

          {token_purchase_types.length > 1 && (
            <React.Fragment>
              <Grid item md={12} />
              <Grid item xs={12}>
                <RadioGroup
                  name="token_purchase_type"
                  value={String(calculator.token_purchase_type_id)}
                  onChange={e => calculateTokenPurchaseType(parseInt(e.target.value, 10))}
                >
                  {_.map(token_purchase_types, ({ id, name, description }) => (
                    <FormControlLabel
                      key={id}
                      value={String(id)}
                      control={<Radio />}
                      label={name}
                    />
                  ))}
                </RadioGroup>

                {(({ description }) => (
                  <div className="alert alert-dismissible alert-warning">{description}</div>
                ))(
                  _.find(token_purchase_types, ({ id }) => calculator.token_purchase_type_id === id)
                )}
              </Grid>
            </React.Fragment>
          )}

          <Grid item md={12} />
        </Grid>
      </Grid>

      <Grid item>
        {config_parameters['purchase_agreements'].length > 0 && (
          <Grid container className="gray-box">
            {false && (
              <Grid item xs={12} md={current_promocode ? 5 : 12} id="add-promotional-code-label">
                <label>{I18n.t('tokens.add_promo_code')}</label>
              </Grid>
            )}
            {false &&
              current_promocode && (
                <Grid item xs={12} md={7} id="active-promotional-code-label">
                  <label>{I18n.t('tokens.active_promo_code')}</label>
                </Grid>
              )}
            {false && (
              <Grid item xs={12} md={current_promocode ? 5 : 12} id="form-token-promocode-box">
                <div className="promo-code-form">
                  <div className="box" style={{ height: '40px' }}>
                    <TextField
                      id="input-form-token-promocode"
                      className="input-form-token-promocode"
                      inputRef={input => (this.promocode = input)}
                    />
                  </div>
                  <Button
                    raised
                    id="btn-token-promocode-add"
                    onClick={() =>
                      addPromocode(this.promocode.value).then(() => {
                        getActivePromocode()
                      })
                    }
                  >
                    {I18n.t('tokens.add')}
                  </Button>
                </div>
              </Grid>
            )}
            {false &&
              current_promocode && (
                <Grid item xs={12} md={7} id="form-token-promocode-current-box">
                  <p>
                    <span className="current-promocode">{current_promocode}</span>
                  </p>
                </Grid>
              )}
            {config_parameters['purchase_agreements'].length > 0 && (
              <Grid item xs={12} className="purchase-agreement">
                {config_parameters['purchase_agreements'].map((purchase_agreement, index) => (
                  <div key={index}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          autoComplete="off"
                          disabled={_.isEmpty(user_balances)}
                          checked={purchase_agreements[index]}
                          onChange={({ target: { checked } }) =>
                            checkPurchaseAgreement({ [index]: checked })
                          }
                        />
                      }
                      label={<span dangerouslySetInnerHTML={{ __html: purchase_agreement }} />}
                    />
                  </div>
                ))}
              </Grid>
            )}
          </Grid>
        )}

        <Grid container>
          <Grid item md={12} />
        </Grid>
        <Grid container>
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            <Button
              raised
              color="primary"
              className="buy-now"
              disabled={_.isEmpty(user_balances) || buy_button_disabled}
              onClick={() =>
                toggleGenerateContract(calculator.all_deposits && !calculator.deposits.one_currency)
              }
            >
              {I18n.t('main.step.buy_form.buttons.buy_now')}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </form>
)

class BuyTokensFormContainer extends Component {
  componentDidMount() {
    const {
      getTokenPurchaseTypes,
      calculateCoinAmount,
      getActivePromocode,
      getDeposits,
      getTokens,
      config_parameters
    } = this.props
    const min_coin_for_payment = config_parameters['coin.min_payment_coins_amount'] || 1
    getTokenPurchaseTypes()
    calculateCoinAmount(min_coin_for_payment)
    getActivePromocode()
    getDeposits()
    getTokens()
  }

  render() {
    return (
      <React.Fragment>
        <Loading active={this.props.loading} />
        <BuyTokensForm {...this.props} />
        <ContractModal />
      </React.Fragment>
    )
  }
}

const purchaseAgreementsSelector = state => state.contracts.index.purchase_agreements
const buyButtonDisabledSelector = createSelector(
  purchaseAgreementsSelector,
  parametersSelector,
  (purchase_agreements, config_parameters) =>
    _.filter(purchase_agreements, checked => checked).length !==
    config_parameters['purchase_agreements'].length
)

const mapStateToProps = state => ({
  user_balances: jsonSelector('users.current.deposits')(state),
  calculator: calculatorSelector('buy_tokens_form', pricesSelector)(state),
  config_parameters: parametersSelector(state),
  available_currencies: parametersSelector(state).available_currencies,
  current_promocode: jsonSelector('users.current.promocodes.active')(state).code,
  token_purchase_types: jsonSelector('contracts.token_purchase_types')(state),
  purchase_agreements: purchaseAgreementsSelector(state),
  buy_button_disabled: buyButtonDisabledSelector(state),
  loading: state.contracts.index.loading
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getTokenPurchaseTypes,
      calculateCoinAmount,
      calculateIncrementCoinAmount,
      calculateDecrementCoinAmount,
      calculateToggleAllDeposits,
      calculateTokenPurchaseType,
      setCode,
      getTokens,
      addPromocode,
      getActivePromocode,
      toggleGenerateContract,
      checkPurchaseAgreement,
      getDeposits
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(BuyTokensFormContainer)



// WEBPACK FOOTER //
// ./src/containers/pages/dashboard/buy_tokens_form.js